import { FEATURE_IDS } from "../constants/featureAccess";

/**
 * Same gate as Invite User on manage-subscription:
 * paid active subscription required (Free plan cannot invite staff).
 */
export const canUseOrganizationStaff = (userPlan) => {
  const planId = parseInt(userPlan?.plan_id, 10);
  return (
    userPlan?.is_paid_subscription === "E" &&
    Number.isFinite(planId) &&
    planId !== 1
  );
};

export const hasPooledAvailability = (features) => {
  if (!features || !Array.isArray(features)) {
    return false;
  }

  const feature = features.find(
    (f) => f.feature_id === FEATURE_IDS.POOLED_AVAILABILITY
  );
  return feature ? feature.status === "E" : false;
};

export const hasStaffConfirmation = (features) => {
  if (!features || !Array.isArray(features)) {
    return false;
  }

  const feature = features.find(
    (f) => Number(f.feature_id) === FEATURE_IDS.STAFF_CONFIRMATION
  );
  return feature ? feature.status === "E" : false;
};

/**
 * Force "My Event" staff assignment when staff features are unavailable.
 * Strip pooled assignment options when Pooled Availability is not on the plan.
 */
export const normalizeStaffAssignmentPayload = (data, userPlan, features = []) => {
  if (!canUseOrganizationStaff(userPlan)) {
    return {
      ...data,
      staff_assignment_type: "1",
      staff_choose: "",
      staff_assignment_method: "",
      staffs: [],
    };
  }

  if (!hasPooledAvailability(features)) {
    const normalized = { ...data };
    if (normalized.staff_choose === "random_choose") {
      normalized.staff_choose = "";
    }
    normalized.staff_assignment_method = "";
    return normalized;
  }

  return data;
};
